"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface RightOfUseAssetsTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [];

export default function RightOfUseAssetsTailoringQuestions({ onBack }: RightOfUseAssetsTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Right-of-Use Assets"
      title="Right-of-Use Assets - Tailoring Questions"
      description="Customize the audit program for Right-of-Use Assets"
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}
